import 'intersection-observer';
import * as React from "react";
import { InView } from 'react-intersection-observer';
import { IOWidget, Updater, fromJSX } from "widgets-for-react";
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod";
import { ImageSize, Link } from "../types.gen";
import { getClassName, link } from "../utils.gen";
import { ImageContainer } from "./ImageContainer.gen";
import { CMSState } from '../../../publicSite/drupalPage/state'

export type QuoteBlockProps = {
  index: number
  text: string
  author?: string
  link?: Link | null
  image?: number
  image_alt?: string
  image_size?: ImageSize
  get_default_data_src:(() => ImageSize)
  get_default_data_srcset:(() => [ImageSize, string][])
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function QuoteBlock(
  props: QuoteBlockProps,
  options?: { style?: QuoteBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
return (cmsState: CMSState) =>
    fromJSX(
      _ => {
        return (
          <InView
            as="figure"
            onChange={(inView) => blockInviewHandler('quote', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.index}`}
            className={getClassName(options, "block_classname", "container")}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            <div className={getClassName(options, "inner_classname", `py-5 ${props.image ? "row" : ""}`)}>
              <div className={getClassName(options, "content_classname", `${props.image ? "col-md-6 mb-4" : "text-center"}`)}>
                <blockquote className={getClassName(options, "quote_classname", "h4")}>
                  <p>{props.text}</p>
                </blockquote>

                {props.author && <figcaption className={getClassName(options, "author_classname", "mb-3 text-muted")}>— {props.author}</figcaption>}
                
                {props.link &&              
                  <footer className={getClassName(options, "footer_classname", "")}>
                    {props.link ? link(props.link, { classname: getClassName(options, "clickable_classname", "btn btn-dark") }, props.link.title) : null}
                  </footer>
                }
              </div>

              {props.image &&
                <div className={getClassName(options, "visual_classname", "col-md-6 mb-4")}>
                  {cmsState.images.has(props.image) &&
                    ImageContainer(
                      cmsState.images.get(props.image),
                      props.image_size,
                      getClassName(options, "image_classname", "w-100"),
                      props.image_alt,
                      props.get_default_data_src,
                      props.get_default_data_srcset
                    ).run(_ => { })}
                </div>}
            </div>
          </InView>
        )
      },
    )
}
